import {
	SET_OFFICE_OPEN_INFO,
	SET_ALERT_SETTING_POPUP,
	SET_ALERT_PREFERENCES,
	RESET_ALERT_PREFERENCES,
	SET_APP_USER_INTERACTION_RECEIVED,
} from '@/store/mutation-types'

const getDefaultAlertPreferences = () => ({
	id: null,
	audio_alert_enabled: false,
	visual_alert_enabled: false,
	inactivity_threshold_minutes: 5,
	alert_sound: null,
	alert_color: 'orange',
})

export default {
	[SET_OFFICE_OPEN_INFO](state, officeOpenInfo) {
		state.officeOpenInfo = officeOpenInfo
	},

	[SET_ALERT_SETTING_POPUP](state, alertSettingsPopup) {
		state.alertSettingsPopup = alertSettingsPopup
	},

	[SET_ALERT_PREFERENCES](state, alertPreferences) {
		state.alertPreferences = {
			...state.alertPreferences,
			...(alertPreferences?.omd || {}),
			...(alertPreferences?.id && { id: alertPreferences.id }),
		}
	},

	[RESET_ALERT_PREFERENCES](state) {
		state.alertPreferences = getDefaultAlertPreferences()
	},

	[SET_APP_USER_INTERACTION_RECEIVED](state, value = true) {
		state.appUserInteractionReceived = Boolean(value)
	},
}
